import { array } from '@disy/lib/array-util';

export type StyleClass = string | string[];

/**
 * Adds one our more style classes to the given element.
 *
 * @param elem - Element to which classes will be added
 * @param [styleClass] - One or more style classes (without dot '.')
 */
export function addStyleClass(elem: Element, styleClass: StyleClass = []) {
  if (Array.isArray(styleClass)) {
    elem.classList.add(...styleClass);
  } else {
    elem.classList.add(styleClass);
  }
}

export function renderStyleClass(styleClass?: StyleClass) {
  return styleClass ? array(styleClass).join(' ') : '';
}
